import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

// Collapsed receipts must not serialize or mount their potentially large payload.
export default React.memo(function ReceivedDetails({ payload, className, labelKey = 'database_show_payload' }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const text = useMemo(() => open ? JSON.stringify(payload, null, 2) : '', [open, payload]);
  return <details aria-label={t(labelKey)} onToggle={(event) => setOpen(event.currentTarget.open)}>
    <summary>{t(labelKey)}</summary>
    {open && <pre className={className}>{text}</pre>}
  </details>;
});
